module.exports = __webpack_public_path__ + "assets/img/19_723_big.c6ec31da.jpg";